import React, { useState, useEffect, useContext, useRef } from "react";
import "./Leadtran.css";
import Url from '../Url';
import { LoginContext } from '../Login/LoginContext';
import { FaGlobeAfrica, FaUser } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Leadtran() {
    const { loginResult } = useContext(LoginContext);
    const user_id = loginResult?.user_id;

    const [employees, setEmployees] = useState([]);
    const [selectedEmployeeDragDrop, setSelectedEmployeeDragDrop] = useState(null);
    const [leadsDragDrop, setLeadsDragDrop] = useState([]);
    const [assignedLeadsDragDrop, setAssignedLeadsDragDrop] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [Data, setData] = useState(null);
    const [popupType, setPopupType] = useState('success'); // New state for popup type (success/error)
    const draggedLeadRef = useRef(null);

    // State for user filtering
    const [showUserFilter, setShowUserFilter] = useState(false);
    const [selectedUserFilter, setSelectedUserFilter] = useState(null);

    // New state for status filtering
    const [showStatusFilter, setShowStatusFilter] = useState(false);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);

    const report_id = 4;
    const save_report_id = 7;

    // Fetch Employees
    const fetchEmployees = () => {
        if (!user_id) return;

        fetch(`${Url.Url}/get_report?data=` + encodeURIComponent(JSON.stringify({
            report_id: 5,
            user_id,
        })))
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data) && Array.isArray(data)) {
                    setEmployees(data);
                } else {
                    setEmployees([]);
                }
            })
            .catch(err => console.error("API Error (Employees):", err));
    };

    const fetchLeads = async () => {
        if (!user_id) return;

        try {
            const response = await fetch(`${Url.Url}/get_report?data=` + encodeURIComponent(JSON.stringify({
                user_id,
                report_id,
            })));

            if (!response.ok) {
                const errorText = await response.text();
                console.error(`HTTP error! status: ${response.status}`, errorText);
                throw new Error(`Server responded with status ${response.status}: ${errorText.substring(0, 100)}...`);
            }

            const result = await response.json();

            if (Array.isArray(result) && Array.isArray(result)) {
                const leadsRaw = result;
                const leadsParsed = leadsRaw.map((lead, index) => {
                    let parsedDetails = {};
                    try {
                        parsedDetails = lead.Details ? JSON.parse(lead.Details) : {};
                    } catch (e) {
                        console.warn("JSON Parse Error for lead Details:", lead.lead_id, e);
                    }
                    return {
                        ...lead,
                        id: lead.lead_id ?? lead.id ?? `lead-${index}`,
                        parsedDetails,
                    };
                });
                setLeadsDragDrop(leadsParsed);
            } else {
                console.warn("API response for leads was not in expected format:", result);
                setLeadsDragDrop([]);
            }
        } catch (error) {
            // Set popup for fetch error
            setPopupType('error');
            setShowPopup(true);
            setData([{ 0: { message: 'Error fetching leads: ' + error.message } }]);
            setTimeout(() => {
                setShowPopup(false);
                setData(null);
            }, 3000);
            setLeadsDragDrop([]);
            console.error("Fetch Leads Error:", error);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchEmployees();
            fetchLeads();
        }
    }, [user_id]);

    useEffect(() => {
        setAssignedLeadsDragDrop([]);
    }, [selectedEmployeeDragDrop]);

    const onDragStart = (lead) => {
        draggedLeadRef.current = lead;
    };

    const onDropAssigned = (e) => {
        e.preventDefault();
        const draggedLead = draggedLeadRef.current;
        if (!draggedLead) return;

        setAssignedLeadsDragDrop((prev) => {
            if (!prev.some(l => l.id === draggedLead.id)) {
                return [...prev, draggedLead];
            }
            return prev;
        });

        setLeadsDragDrop((prev) => prev.filter(l => l.id !== draggedLead.id));
        draggedLeadRef.current = null;
    };

    const onDropLeads = (e) => {
        e.preventDefault();
        const draggedLead = draggedLeadRef.current;
        if (!draggedLead) return;

        setLeadsDragDrop((prev) => {
            if (!prev.some(l => l.id === draggedLead.id)) {
                return [...prev, draggedLead];
            }
            return prev;
        });

        setAssignedLeadsDragDrop((prev) => prev.filter(l => l.id !== draggedLead.id));
        draggedLeadRef.current = null;
    };

    const onDragOver = (e) => {
        e.preventDefault();
    };

    const handleEmployeeChangeDragDrop = (e) => {
        const empId = e.target.value;
        const emp = employees.find(emp => emp.user_id?.toString() === empId);
        setSelectedEmployeeDragDrop(emp || null);
    };

    const handleSaveAssignmentsDragDrop = () => {
        if (!selectedEmployeeDragDrop) {
            setPopupType('error'); // Set type to error
            setShowPopup(true);
            setData([{ 0: { message: "Please select an employee first." } }]);
            setTimeout(() => {
                setShowPopup(false);
                setData(null);
            }, 2000);
            return;
        }

        if (assignedLeadsDragDrop.length === 0) {
            setPopupType('error'); // Set type to error
            setShowPopup(true);
            setData([{ 0: { message: "No leads assigned to transfer." } }]);
            setTimeout(() => {
                setShowPopup(false);
                setData(null);
            }, 2000);
            return;
        }

        const leadIds = assignedLeadsDragDrop.map(lead => lead.id);

        const payload = {
            user_id: user_id,
            employee_id: selectedEmployeeDragDrop.user_id,
            lead_ids: leadIds,
            report_id: save_report_id
        };
        console.log(JSON.stringify(payload))

        const queryString = encodeURIComponent(JSON.stringify(payload));
        const apiUrl = `${Url.Url}/get_report?data=${queryString}`;

        fetch(apiUrl)
            .then(res => res.json())
            .then(data => {
                setPopupType('success'); // Set type to success
                setShowPopup(true);
                setData(data);
                console.log(data)
                setTimeout(() => {
                    setShowPopup(false);
                    setData(null);
                    setAssignedLeadsDragDrop([]);
                    fetchLeads(); // Call fetchLeads directly to refresh
                }, 2000);
            })
            .catch(err => {
                setPopupType('error'); // Set type to error
                setShowPopup(true);
                setData([{ 0: { message: "Error saving assignments: " + err.message } }]);
                setTimeout(() => {
                    setShowPopup(false);
                    setData(null);
                }, 3000);
            });
    };

    const renderLeadDetails = (lead) => {
        const fieldsToDisplay = [
            "CompanyName",
            "ContactPerson",
            "LeadSource",
            "LeadDate",
            "Address",
            "Mobile",
            "UserName",
            "Status",
        ];

        const getFieldValue = (field) =>
            lead.parsedDetails?.[field] ?? lead[field] ?? "N/A";

        return fieldsToDisplay.map((field) => (
            <div key={field} className="lead-detail-item">
                <span className="lead-detail-label">{field}:</span>{" "}
                <span className="lead-detail-value">{getFieldValue(field)}</span>
            </div>
        ));
    };

    // Function to get unique usernames from leadsDragDrop
    const getUniqueUsernames = () => {
        const usernames = new Set();
        leadsDragDrop.forEach(lead => {
            if (lead.UserName) {
                usernames.add(lead.UserName);
            }
        });
        return Array.from(usernames);
    };

    // New function to get unique statuses from leadsDragDrop
    const getUniqueStatuses = () => {
        const statuses = new Set();
        leadsDragDrop.forEach(lead => {
            if (lead.Status) { // Assuming 'Status' is the field containing the status
                statuses.add(lead.Status);
            }
        });
        return Array.from(statuses);
    };

    // Filter leads based on selectedUserFilter AND selectedStatusFilter
    const filteredLeads = leadsDragDrop.filter(lead => {
        const matchesUser = selectedUserFilter
            ? lead.UserName === selectedUserFilter
            : true;
        const matchesStatus = selectedStatusFilter
            ? lead.Status === selectedStatusFilter
            : true;
        return matchesUser && matchesStatus;
    });


    return (
        <div>
           
            {showPopup && Data && (
                <div className={`popup-message ${popupType}`}> {/* Apply dynamic class */}
                    <p>{Data[0]?.[0]?.message || (typeof Data[0] === 'string' ? Data[0] : 'Lead Transferred sucessfully')}</p>
                </div>
            )}
            <h2 className="main-title">Existing Leads</h2>
            <div className="boxes-wrapper">
                <div
                    onDrop={onDropLeads}
                    onDragOver={onDragOver}
                    className="leads-box"
                >
                    <div className="leads-header">
                        <h4>Available Leads</h4>
                        <div className="filter-icons-group">
                            <div className="filter-container">
                                <button className="filter-icon" onClick={() => {
                                    setShowUserFilter(!showUserFilter);
                                    setShowStatusFilter(false);
                                }}>
                                    <FaUser />
                                </button>
                                {showUserFilter && (
                                    <div className="filter-dropdown">
                                        <div
                                            className="filter-option"
                                            onClick={() => {
                                                setSelectedUserFilter(null);
                                                setShowUserFilter(false);
                                            }}
                                        >
                                            All Users
                                        </div>
                                        {getUniqueUsernames().map(username => (
                                            <div
                                                key={username}
                                                className="filter-option"
                                                onClick={() => {
                                                    setSelectedUserFilter(username);
                                                    setShowUserFilter(false);
                                                }}
                                            >
                                                {username}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="filter-container">
                                <button className="filter-icon" onClick={() => {
                                    setShowStatusFilter(!showStatusFilter);
                                    setShowUserFilter(false);
                                }}>
                                    <FaGlobeAfrica />
                                </button>
                                {showStatusFilter && (
                                    <div className="filter-dropdown">
                                        <div
                                            className="filter-option"
                                            onClick={() => {
                                                setSelectedStatusFilter(null);
                                                setShowStatusFilter(false);
                                            }}
                                        >
                                            All Statuses
                                        </div>
                                        {getUniqueStatuses().map(status => (
                                            <div
                                                key={status}
                                                className="filter-option"
                                                onClick={() => {
                                                    setSelectedStatusFilter(status);
                                                    setShowStatusFilter(false);
                                                }}
                                            >
                                                {status}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {filteredLeads.length === 0 && <p className="placeholder-text">No available leads.</p>}
                    {filteredLeads.map((lead) => (
                        <div
                            key={lead.id}
                            draggable
                            onDragStart={() => onDragStart(lead)}
                            className="lead-tile"
                            title={lead.CompanyName}
                        >
                            {renderLeadDetails(lead)}
                        </div>
                    ))}
                </div>

                <div
                    onDrop={onDropAssigned}
                    onDragOver={onDragOver}
                    className="assigned-box"
                >
                    <h3>
                        Assigned Leads to
                        <select
                            value={selectedEmployeeDragDrop?.user_id || ""}
                            onChange={handleEmployeeChangeDragDrop}
                            className="employee-dropdowns"
                        >
                            <option value="" disabled>Select Employee</option>
                            {employees.map((emp) => (
                                <option key={emp.user_id} value={emp.user_id}>
                                    {emp.Name}
                                </option>
                            ))}
                        </select>
                    </h3>
                    {assignedLeadsDragDrop.length === 0 && <p className="placeholder-text">Drag leads here to assign.</p>}
                    {assignedLeadsDragDrop.map((lead) => (
                        <div
                            key={lead.id}
                            draggable
                            onDragStart={() => onDragStart(lead)}
                            className="lead-tile assigned"
                            title={lead.CompanyName}
                        >
                            {renderLeadDetails(lead)}
                        </div>
                    ))}
                </div>
            </div>
            {selectedEmployeeDragDrop && (
                <div className="save-button-container">
                    <button
                        onClick={handleSaveAssignmentsDragDrop}
                        className="save-assignments-btn"
                    >
                        Transfer
                    </button>
                </div>
            )}
        </div>
    );
}